export default "__VITE_ASSET__4daba6c6__"